import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import * as ProductLevels from 'self-service-api/constants/ProductLevels';
import { useSelector } from 'react-redux';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import ProductInfoContainer from '../../components/common/ProductInfoContainer';
import HC0124CompareProFeatureTable from '../../components/feature-table/HC0124CompareProFeatureTable';
import { HC0124_HUB_PRO_PLUS_UPGRADE_PAGE } from '../../constants/ErrorBoundaryNames';
import { isUngatedForUpgradePagePopularFeaturesSelector } from '../../selectors/GatingSelectors';
import ComparePlansLink from '../ComparePlansLink';
import { withErrorBoundary } from '../ErrorBoundary';
import HC0124UpgradeHeroBanner from '../HC0124UpgradeHeroBanner';
import { ProPlusSupportContent } from '../ProPlusSupportContent';
import PopularFeaturesPanel from '../popularFeaturesPanel/PopularFeaturesPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HC0124HubProPlusUpgradePage = ({
  upgradePointApiName,
  upgradeConfig,
  purchaseMotions,
  handlePurchaseMotionButtonClick,
  upgradeSource
}) => {
  const isUngatedForUpgradePagePopularFeatures = useSelector(isUngatedForUpgradePagePopularFeaturesSelector);
  const productLevel = getProductLevelFromApiNameString(upgradePointApiName);
  useEffect(() => {
    getUsageTracker().track('upgradesInteraction', {
      action: 'viewed personalized pricing page',
      upgradeSource,
      upgradeKey: upgradeConfig.upgradeKey,
      apiName: upgradePointApiName
    });
    // keep empty dependency array so not to repeat event and exposure log
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "HC0124-pro-plus-upgrade-page",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "PRO_PLUS_UPGRADE_PAGE"
    }), /*#__PURE__*/_jsx(HC0124UpgradeHeroBanner, {
      upgradeConfig: upgradeConfig,
      upgradePointApiName: upgradePointApiName,
      purchaseMotions: purchaseMotions,
      handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
    }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
      className: "m-all-auto",
      children: [/*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(ProPlusSupportContent, {}), productLevel === ProductLevels.PROFESSIONAL && isUngatedForUpgradePagePopularFeatures ? /*#__PURE__*/_jsx(PopularFeaturesPanel, {
        upgradeConfig: upgradeConfig,
        apiName: upgradePointApiName,
        productLevel: productLevel
      }) : null, /*#__PURE__*/_jsx(HC0124CompareProFeatureTable, {
        upgradePointApiName: upgradePointApiName,
        purchaseMotions: purchaseMotions,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick,
        feature: upgradeConfig.feature
      })]
    })]
  });
};
export default withErrorBoundary(HC0124HubProPlusUpgradePage, {
  boundaryName: HC0124_HUB_PRO_PLUS_UPGRADE_PAGE,
  redirectCallback: () => '/'
});